import useTrackerBasicInfo from 'hooks/useTrackerBasicInfo';
import { SendAssignmentEventParams } from 'utils/firebase/sendAssignmentTracker';

interface UseSendAssignmentEventParamsProps {
  courseId?: string;
  unitId?: string;
  topicId?: string;
}

const useSendAssignmentEventParams = ({
  courseId = '',
  unitId,
  topicId,
}: UseSendAssignmentEventParamsProps = {}): SendAssignmentEventParams => {
  const trackerBasicInfo = useTrackerBasicInfo();

  return {
    ...trackerBasicInfo,
    course_id: courseId,
    ...(unitId !== undefined && { unit_id: unitId }),
    ...(topicId !== undefined && { topic_id: topicId }),
  };
};

export default useSendAssignmentEventParams;
